module.exports = __webpack_public_path__ + "img/img-e1648e.png";